export default {
  name: 'AppVersion',

  data() {
    return {
      version: process.env.APP_VERSION,
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/AppVersion/component.js